import { useRecoilState } from 'recoil';
import { cartState } from '../store/cartAtom';
import { useEffect } from 'react';

const CART_EXPIRATION_TIME = 31 * 24 * 60 * 60 * 1000; // 1 month in milliseconds

export const useCart = () => {
  const [cart, setCart] = useRecoilState(cartState);

  // Load cart from localStorage on initialization
  useEffect(() => {
    const savedCart = localStorage.getItem('cart');
    const savedTimestamp = localStorage.getItem('cartTimestamp');
    if (savedCart && savedTimestamp) {
      const currentTime = Date.now();
      const cartAge = currentTime - parseInt(savedTimestamp, 10);

      if (cartAge < CART_EXPIRATION_TIME) {
        setCart(JSON.parse(savedCart));
      } else {
        // Clear expired cart
        localStorage.removeItem('cart');
        localStorage.removeItem('cartTimestamp');
      }
    }
  }, [setCart]);

  // Save cart to localStorage whenever it changes
  useEffect(() => {
    if (cart.length > 0) {
      localStorage.setItem('cart', JSON.stringify(cart));
      localStorage.setItem('cartTimestamp', Date.now().toString());
    } else {
      localStorage.removeItem('cart');
      localStorage.removeItem('cartTimestamp');
    }
  }, [cart]);

  const addToCart = (item) => {
    setCart((prevCart) => {
      const exists = prevCart.find((cartItem) => cartItem.id === item.id);
      if (exists) {
        // Update only the shippingInfo for the existing item
        return prevCart.map((cartItem) =>
          cartItem.id === item.id
            ? { ...cartItem, shippingInfo: item.shippingInfo }
            : cartItem
        );
      }
      // Add new item with its shippingInfo
      return [...prevCart, { ...item, shippingInfo: item.shippingInfo }];
    });
  };

  const removeFromCart = (itemId) => {
    setCart((prevCart) => prevCart.filter((item) => item.id !== itemId));
  };

  const updateShippingInfo = (itemId, shippingInfo) => {
    setCart((prevCart) =>
      prevCart.map((item) =>
        item.id === itemId
          ? { ...item, shippingInfo: { ...item.shippingInfo, ...shippingInfo } }
          : item
      )
    );
  };

  return { cart, addToCart, removeFromCart, updateShippingInfo };
};